import { Activity } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "createActivity",
  initialState: {} as SliceState<Omit<Activity, "id">>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const createActivityReducer = formSlice.reducer;
export default createActivityReducer;
